var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30026 4.3L0.700256 1.7C0.383589 1.38333 0.312923 1.021 0.488256 0.613C0.66359 0.205 0.975923 0.000666667 1.42526 0H6.57526C7.02526 0 7.33792 0.204333 7.51326 0.613C7.68859 1.02167 7.61759 1.384 7.30026 1.7L4.70026 4.3C4.60026 4.4 4.49192 4.475 4.37526 4.525C4.25859 4.575 4.13359 4.6 4.00026 4.6C3.86692 4.6 3.74192 4.575 3.62526 4.525C3.50859 4.475 3.40026 4.4 3.30026 4.3Z",
    fill: "#C0C0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownGray);
export default __webpack_public_path__ + "static/media/caretDownGray.17add5aa9a8d6727628749cf069bccd8.svg";
export { ForwardRef as ReactComponent };